import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { BalanceModel } from 'src/app/models/balance-model';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { Navigator } from 'src/app/services/routing/navigator';

@Component({
    selector: 'app-withdrawal-venmo',
    templateUrl: './withdrawal-venmo.component.html',
    styleUrls: ['./withdrawal-venmo.component.scss'],
})

export class WithdrawalVenmoComponent extends WithdrawalBaseComponent implements OnInit {
    @ViewChild(IonContent, { static: false }) content: IonContent;

    public accountBalances: BalanceModel;
    public disableWithdrawButton: boolean = false;
    public enterCounts = 0;
    public enterPressed: boolean;
    public error = null;

    public withdrawalForm: FormGroup;
    public amount: AbstractControl;
    public accounts: any = [];
    public hasDeposit: boolean = false;

    constructor(
        private balanceService: AccountBalanceService,
        private withdrawService: WithdrawalService,
        private events: EventsService,
        private successMessageService: SuccessMessageService,
        public cashierService: CashierService,
        public navigator: Navigator
    ) {
        super();
        this.successMessageService.clearMessage();
        this.error = null;
    }


    ngOnInit(): void {
        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                currency_code: new FormControl(''),
                payment_type_code: new FormControl(''),
            }
        )

        this.amount = this.withdrawalForm.get('amount');

        this.onGetBalance();
        this.onGetAccounts();
    }

    public onGetAccounts(): any {
        this.hasDeposit = false;
        this.accounts = [];
        this.cashierService.callListAccounts().subscribe(
            (response) => {
                if (response?.result) {
                    this.accounts = response?.payload.filter(
                        account => account.paymentTypeCode === "VEN" && account.dpstCnt > 0
                    );
                    this.hasDeposit = this.accounts.length > 0;
                    return;
                }
            }
        );
    }

    private onGetBalance(): void {
        this.balanceService.getBalance().subscribe(
            (balance: BalanceModel) => {
                if (balance) {
                    this.accountBalances = balance;
                }
            }
        );

        this.error = null;
    }

    public onSubmit(): void {
        this.disableWithdrawButton = true;
        this.successMessageService.clearMessage();
        this.error = null;
        this.withdrawalForm.get("currency_code").setValue(this.withdrawService.customer.preferredCurrency.currencyCode);
        this.withdrawalForm.get("payment_type_code").setValue("VEN");

        this.withdrawService.callWithdraw(this.withdrawalForm.value).subscribe((response): any => {

            if (response && !!response.result) {
                // send the withdrawal event
                let depositEventData = {
                    customerId: this.withdrawService.customer.customerId,
                    amount: this.withdrawalForm.get('amount').value
                }
                setTimeout(() => this.events.publish('event:withdraw', depositEventData), 2000);
                this.amount.setValue('');
                this.amount.markAsPristine();
                this.amount.markAsUntouched();
                this.successMessageService.setMessage('Your withdrawal request has been received.');
                this.balanceService.updateBalance();
                this.content.scrollToTop();
                this.disableWithdrawButton = false;
            }

        }, (error) => {
            this.disableWithdrawButton = false;
            this.error = this.handleError(error);
        });

        setTimeout(() => {
            this.enterCounts = 0;
        }, 3000);
    }

    public toVenmoDeposit(): any {
        return this.navigator.navigateTo("DepositVenmoComponent", {}, { navigateBackPage: "WithdrawalVenmoComponent" });
    }
}
